import { LOGO_RATIO } from '@mews-distributor/common';
import { ImageResizeMode } from '@mews/enums';
import { propertyLogoFactory } from '@mews/gx-ui';
import { ServerImage } from '../../service';

const logoSizes = '(max-width: 500px) 25vw, (max-width: 800px) 20vw, (max-width: 1300px) 15vw, 10vw';
const widthSet = [240, 320, 480, 640];

interface ServerImageProps {
    id?: string | null;
}

export const Logo = propertyLogoFactory<ServerImageProps>({
    ImageComponent: (props) =>
        props.id != null ? (
            <ServerImage
                mode={ImageResizeMode.FitExact}
                sizes={logoSizes}
                widthSet={widthSet}
                ratio={LOGO_RATIO}
                {...props}
            />
        ) : null,
});
